const columns = (renderCell) => {
  return [
    {
      field: 'RigName_Number',
      headerName: 'Rig',
      width: 200,
      hide: false,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'customerName',
      headerName: 'Customer',
      width: 350,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'timestamp',
      headerName: 'Date',
      width: 250,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'referenceCategory',
      headerName: 'Search Category',
      width: 300,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'referenceCategoryTargetSpend',
      headerName: 'Target Spend',
      width: 250,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'referenceSpend',
      headerName: 'Search Spend',
      width: 250,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'userEmail',
      headerName: 'User Email',
      width: 300,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'answers',
      headerName: 'Response',
      width: 300,
      renderCell,
      headerAlign: 'center',
      align: 'center',
    },
  ];
};

export default columns;
